module.exports = "<h1 matDialogTitle>Confirm</h1>\r\n<div mat-dialog-content>{{confirmMessage}}</div>\r\n<div mat-dialog-actions class=\"pt-24\">\r\n    <button mat-raised-button class=\"mat-accent mr-16\" (click)=\"dialogRef.close(true)\">Confirm</button>\r\n    <button mat-button (click)=\"dialogRef.close(false)\">Cancel</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/REPO/FacturacionWeb/src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/core/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main